module.exports = __webpack_public_path__ + "img/rynenation-logo-light-large.0fc361d4.png";